export function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max))
}

// return boolean from string
export function getBoolean(value) {
    switch (value) {
        case true:
        case 'true':
        case 1:
        case '1':
        case 'on':
        case 'yes':
            return true
        default:
            return false
    }
}

export const ADDRESS = 'Vahrenwalder Str. 213, 30165, Hannover'
export const COMPANY = 'First Class Performance GmbH'
export const MAIL = 'moritz@first-class-performance.com'

export const COLOR_PRIMARY = '#fff'
export const COLOR_SECONDARY = '#22cae2'
export const COLOR_BACKGROUND = '#f5f5f5'

// @ts-ignore
const domain = ''

// IMAGES COURSES
export const IMAGE_ENDURANCE = `${domain}/images/courses/endurance.jpg`

// IMAGES HEADER
export const IMAGE_LOGO = `${domain}/icons/firstclasslogo_schwarz.png`
export const IMAGE_LOGO_VIDEO = `${domain}/icons/firstclasslogo_weiss-colored.png`

// IMAGES TEAM
export const IMAGE_ANITA = `${domain}/images/team/anita.png`
export const IMAGE_BIRTHE = `${domain}/images/team/birthe.png`
export const IMAGE_DENNIS = `${domain}/images/team/dennis.png`
export const IMAGE_FLORIAN = `${domain}/images/team/florian.jpg`
export const IMAGE_FREYA = `${domain}/images/team/freya.jpg`
export const IMAGE_KNOTTI = `${domain}/images/team/knotti.png`
export const IMAGE_LUCA = `${domain}/images/team/luca.png`
export const IMAGE_JENNY = `${domain}/images/team/jenny.png`
export const IMAGE_MELANIE = `${domain}/images/team/melanie.png`
export const IMAGE_MORITZ = `${domain}/images/team/moritz.png`
export const IMAGE_NICOLE = `${domain}/images/team/nicole.png`
export const IMAGE_PATRICIA = `${domain}/images/team/patricia.png`
export const IMAGE_TOM = `${domain}/images/team/tom.png`
export const IMAGE_DENNIS_2 = `${domain}/images/team/dennis2.jpg`
export const IMAGE_JULIA = `${domain}/images/team/julia.jpg`
export const IMAGE_CONNY = `${domain}/images/team/conny.jpg`

// IMAGES STUDIO
export const IMAGE_STUDIO_1 = `${domain}/images/studio/studio1.jpg`
export const IMAGE_STUDIO_2 = `${domain}/images/studio/studio2.jpg`
export const IMAGE_STUDIO_3 = `${domain}/images/studio/studio3.jpg`
export const IMAGE_STUDIO_4 = `${domain}/images/studio/studio4.jpg`
export const IMAGE_STUDIO_5 = `${domain}/images/studio/studio5.jpg`
export const IMAGE_STUDIO_6 = `${domain}/images/studio/studio6.jpg`
export const IMAGE_STUDIO_7 = `${domain}/images/studio/studio7.jpg`
export const IMAGE_STUDIO_8 = `${domain}/images/studio/studio8.jpg`
export const IMAGE_STUDIO_9 = `${domain}/images/studio/studio9.jpg`
export const IMAGE_STUDIO_10 = `${domain}/images/studio/studio10.jpg`
export const IMAGE_STUDIO_11 = `${domain}/images/studio/studio11.jpg`
export const IMAGE_STUDIO_12 = `${domain}/images/studio/studio12.jpg`
